import { Card } from '@hivebrite/design-system/Card';

import Grid, {
  Col,
  Row,
  getBpNum,
} from 'hb-react/shared/components/DesignSystem/Grid';

const PasswordChangeWrapper = ({ children }) => (
  <Grid>
    <Row>
      <Col
        offset={({ numCols }) => ({
          _: 0,
          m: 2 / getBpNum(numCols, 'm'),
          l: 3 / getBpNum(numCols, 'l'),
          xl: 4 / getBpNum(numCols, 'xl'),
        })}
        width={({ numCols }) => ({
          _: 12 / getBpNum(numCols, '_'),
          m: 8 / getBpNum(numCols, 'm'),
          l: 6 / getBpNum(numCols, 'l'),
          xl: 4 / getBpNum(numCols, 'xl'),
        })}
      >
        <Card>{children}</Card>
      </Col>
    </Row>
  </Grid>
);

export default PasswordChangeWrapper;
